import { CLIENTTAB, } from 'Constants';
import React, { useState } from 'react'
import { useParams} from 'react-router-dom';
import CaseBaseInfo from './CaseBaseInfo';
import Template from 'Components/Templates/Template';
import Header from 'Components/Header/Header';

function CaseDetails() {
    const {id} = useParams();
    const [activeTab, setActiveTab] = useState(0);
    return (
        <>
        <Header />  
        <div className='flex col-span-6  w-full flex-col'>
       
        <CaseBaseInfo id={id}/>
        </div>
        </>
    )
}

export default CaseDetails;